// ── 직원 관리 — 메인 스타일 상수 ─────────────────────────────────────────────
// 어드민 테마: 흰색 카드, 미묘한 그림자, 정제된 타이포그래피

/* ── 2026-08-26 디자인 실험: 홈 스타일 헤더 (박스 없이 텍스트 + 상황판 버튼 2종) ── */
/* 큰 제목 — 두께 700 (2026-08-26 사용자 조정, 900→700) */
export const pageTitleXLStyle = {
  margin: 0,
  fontSize: 26,
  fontWeight: 700,
  letterSpacing: '-0.02em',
  color: 'var(--text)',
};

/* 제목 아래 한 줄 부제 */
export const pageSubtitleStyle = {
  marginTop: 4,
  fontSize: 12,
  color: 'var(--text-muted)',
};

/* 직원 검색칸 (홈 '기능 검색'과 동일 톤) — 아이콘 자리 왼쪽 패딩 포함 */
export const searchWrapStyle = (isMobile) => ({
  position: 'relative',
  maxWidth: isMobile ? '100%' : 400,
  marginBottom: 40, // 2026-08-26 사용자 조정: 28→40 (검색창↔표 간격 확대)
});
export const searchInputStyle = {
  width: '100%',
  boxSizing: 'border-box',
  border: '1px solid var(--border)',
  borderRadius: 12,
  padding: '10px 12px 10px 34px',
  fontSize: 13,
  color: 'var(--text)',
  background: 'var(--bg-card)',
  outline: 'none',
};
export const searchIconStyle = {
  position: 'absolute',
  left: 12,
  top: '50%',
  transform: 'translateY(-50%)',
  color: 'var(--text-muted)',
  pointerEvents: 'none',
};

/* 검정 박스 버튼 (상황판 '+ 위젯' 톤) — 주요 액션 */
export const blackBtn = {
  border: '1px solid var(--std-btn, #0f172a)',
  borderRadius: 12,
  padding: '8px 14px',
  background: 'var(--std-btn, #0f172a)',
  color: '#fff',
  fontWeight: 700,
  fontSize: 12,
  cursor: 'pointer',
};

/* 흰 외곽선 박스 버튼 (상황판 '새로고침' 톤) — 보조 액션 */
export const outlineBtn = {
  border: '1px solid var(--border)',
  borderRadius: 12,
  padding: '8px 14px',
  background: 'var(--bg-card)',
  color: 'var(--text-sub)',
  fontWeight: 700,
  fontSize: 12,
  cursor: 'pointer',
};

/* 흰 외곽선 토글 — 활성이면 진한 글씨·진한 테두리 */
export const outlineToggle = (active) => ({
  ...outlineBtn,
  ...(active
    ? { color: 'var(--text)', borderColor: 'var(--text-sub)', fontWeight: 800 }
    : { color: 'var(--text-muted)' }),
});

/* (구) 페이지 헤더 카드: 상단 제목/탭/버튼 영역을 흰색 카드로 감싸는 컨테이너 */
export const pageHeaderCard = {
  background: 'var(--bg-card)',
  borderRadius: 14,
  boxShadow: 'none',
  padding: '18px 20px',
  marginBottom: 20,
  border: '1px solid var(--border)',
};

/* 페이지 제목: 굵고 어두운 색상으로 섹션 타이틀 강조 */
export const pageTitleStyle = {
  margin: 0,
  fontSize: 20,
  fontWeight: 900,
  color: 'var(--text)',
};

/* 상단 행 레이아웃: 제목과 액션 영역을 양쪽 끝으로 배치 */
export const topRowStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 8,
  flexWrap: 'wrap',
};

/* 상단 액션 영역: 모바일에서는 2열 그리드, 데스크탑에서는 flex 행 */
export const topActionsStyle = (isMobile) => (
  isMobile
    ? { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, width: '100%' }
    : { display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }
);

/* 탭 그룹 컨테이너: 재직중/전체 탭을 세그먼트 컨트롤처럼 감싸는 pill 형태 배경 */
export const tabGroupStyle = {
  background: 'var(--bg-subtle)',
  borderRadius: 999,
  padding: 3,
  display: 'inline-flex',
};

/* 탭 버튼: 활성/비활성 상태에 따라 흰색 배경+그림자 또는 투명 배경으로 분기 */
export const tabBtn = (active) =>
  active
    ? {
        // 2026-08-26 사용자 조정: 활성 = 사이드바 선택 메뉴와 같은 색조합 (연파랑 배경 + 파란 글씨)
        background: 'var(--std-pill-on-bg, rgba(59,154,242,0.12))',
        borderRadius: 999,
        padding: '5px 14px',
        fontWeight: 700,
        fontSize: 12,
        border: 'none',
        cursor: 'pointer',
        color: 'var(--std-pill-on-text, #1d7de6)',
      }
    : {
        background: 'transparent',
        border: 'none',
        padding: '5px 14px',
        fontWeight: 600,
        fontSize: 12,
        color: 'var(--text-muted)',
        cursor: 'pointer',
        borderRadius: 999,
      };

/* 폼 그리드: 모달 내 입력 필드들을 반응형 그리드로 배치 */
export const formGridStyle = { display: 'grid', gap: 10, gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' };

/* 테이블 래퍼 — 2026-08-26 사용자 조정: 라운드 12→8, 그림자 옅게(0.06→0.03) */
export const tableWrapStyle = {
  overflowX: 'auto',
  background: 'var(--bg-card)',
  borderRadius: 8,
  overflow: 'hidden',
  border: '1px solid var(--border)',
  boxShadow: 'none', // 2026-08-26 사용자 조정: 하단 그림자가 두꺼운 선처럼 보여 제거
};

/* 테이블 기본 스타일: 너비 꽉 채우고 셀 간격 제거 */
export const tableStyle = { width: '100%', borderCollapse: 'collapse' };

/* 테이블 헤더 셀 스타일 */
export const thStyle = {
  // 2026-08-26 사용자 조정: 머리글 띠 회색→검정(흰 글씨, 검정 버튼과 동일 톤)
  background: 'var(--std-thead, #0f172a)',
  padding: '10px 12px',
  fontSize: 11,
  fontWeight: 600,
  color: 'rgba(255,255,255,0.92)',
  borderBottom: 'none',
  textAlign: 'left',
  whiteSpace: 'nowrap',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

/* 테이블 데이터 셀 스타일 */
export const tdStyle = {
  padding: '10px 12px',
  fontSize: 13,
  borderBottom: '1px solid var(--bg-subtle)',
  color: 'var(--text)',
  verticalAlign: 'middle',
};

/* 페이지네이션 컨테이너: 중앙 정렬, 버튼과 페이지 번호 간격 확보 */
export const paginationWrapStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 10,
  marginTop: 16,
};

/* 페이지네이션 버튼 */
export const paginationBtn = {
  border: '1px solid var(--border)',
  borderRadius: 7,
  padding: '6px 16px',
  background: 'var(--bg-card)',
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: 13,
  color: 'var(--text-sub)',
};

/* 모바일 카드 목록 컨테이너: 카드 간 간격 확보 */
export const mobileListWrapStyle = { display: 'grid', gap: 12 };

/* 모바일 카드: 각 직원 정보를 감싸는 흰색 카드 (테두리, 둥근 모서리, 내부 간격) */
export const mobileCardStyle = {
  background: 'var(--bg-card)',
  border: '1px solid var(--border)',
  borderRadius: 14,
  boxShadow: 'none',
  padding: '14px 16px',
  display: 'grid',
  gap: 10,
};

/* 모바일 카드 헤더: 이름과 상태 배지를 양쪽 끝으로 배치 */
export const mobileCardHeadStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
};

/* 모바일 정보 그리드: 2열 그리드로 키-값 쌍 나열 */
export const mobileInfoGridStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 8,
};

/* 모바일 정보 항목: 키와 값을 세로로 쌓는 레이아웃 */
export const mobileInfoItemStyle = {
  display: 'grid',
  gap: 2,
  minWidth: 0,
};

/* 모바일 정보 키 레이블: 작고 회색인 라벨 텍스트 */
export const mobileInfoKeyStyle = { color: 'var(--text-muted)', fontSize: 11, fontWeight: 700 };

/* 모바일 액션 버튼 그리드: 수정/비번초기화/퇴직처리 버튼 2열 배치 */
export const mobileActionGridStyle = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 };

/* 모바일 빈 상태: 로딩 중이거나 데이터 없을 때 카드 형태로 안내 표시 */
export const mobileEmptyStyle = {
  border: '1px solid var(--border)',
  borderRadius: 12,
  background: 'var(--bg-card)',
  boxShadow: 'none',
  padding: 20,
  textAlign: 'center',
  color: 'var(--text-muted)',
  fontSize: 14,
};

/* 입력 필드 */
export const inputStyle = {
  border: '1px solid var(--border)',
  borderRadius: 7,
  padding: '9px 12px',
  fontSize: 13,
  color: 'var(--text)',
  background: 'var(--bg-card)',
  outline: 'none',
};

/* 일반 버튼 */
export const btn = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '8px 16px',
  background: 'var(--bg-card)',
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: 13,
  color: 'var(--text-sub)',
};

/* 주요 액션 버튼: 블루 CTA */
export const primaryBtn = {
  ...btn,
  background: '#1d4ed8',
  borderColor: '#1d4ed8',
  color: '#fff',
};

/* 퇴직처리 버튼: 중립 회색 */
export const resignBtn = { ...btn, background: 'var(--bg-subtle)', borderColor: 'var(--border)', color: 'var(--text-sub)' };

/* 테이블 행 안 액션 버튼: 작게 (2026-08-25 사용자 피드백 — 버튼이 커서 글씨 칸이 눌림).
   모바일 카드 버튼은 터치 크기 유지(btn 그대로), 데스크톱 표 안에서만 축소형 사용. */
export const tableActionBtn = { ...btn, padding: '4px 10px', fontSize: 12, borderRadius: 6 };
export const tableResignBtn = { ...tableActionBtn, background: 'var(--bg-subtle)', color: 'var(--text-sub)' };

/* 관리 칸: 버튼 내용만큼만 차지 → 남는 폭을 글씨 칸들에 배분 */
export const actionColStyle = { width: '1%', whiteSpace: 'nowrap' };

/* 재직 상태 배지 — 2026-08-26 사용자 조정: 초록 → 토글·사이드바 활성과 같은 연파랑+파랑 조합 */
export const activeBadgeStyle = {
  display: 'inline-block',
  background: 'var(--std-badge-bg, rgba(59,154,242,0.12))',
  color: 'var(--std-badge-text, #1d7de6)',
  border: 'none',
  borderRadius: 999,
  padding: '3px 11px',
  fontWeight: 700,
  fontSize: 12,
};

/* 퇴직 상태 배지: 회색 배경으로 퇴직 상태 표시 */
export const resignedBadgeStyle = {
  display: 'inline-block',
  background: 'var(--border)',
  color: 'var(--text-sub)',
  border: '1px solid var(--border)',
  borderRadius: 999,
  padding: '2px 10px',
  fontWeight: 700,
  fontSize: 12,
};

/* gmail 접미사 표시: 이메일 입력 필드 오른쪽에 고정 위치로 표시 */
export const gmailSuffixStyle = {
  position: 'absolute',
  right: 12,
  top: '50%',
  transform: 'translateY(-50%)',
  color: 'var(--text-muted)',
  pointerEvents: 'none',
};

/* 도움말 텍스트: 폼 하단에 작은 회색 안내 문구 */
export const helperTextStyle = { margin: 0, color: 'var(--text-muted)', gridColumn: '1 / -1' };
